import { render, staticRenderFns } from "./dev-blog.vue?vue&type=template&id=dc567a18&scoped=true"
import script from "./dev-blog.vue?vue&type=script&lang=ts"
export * from "./dev-blog.vue?vue&type=script&lang=ts"
import style0 from "./dev-blog.vue?vue&type=style&index=0&id=dc567a18&prod&lang=css"
import style1 from "./dev-blog.vue?vue&type=style&index=1&id=dc567a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc567a18",
  null
  
)

export default component.exports